class utils {
    static roundNumber(number, decimalPlaces) {
        return Number(number.toFixed(decimalPlaces));
    }
}

export default utils;